<script setup lang="ts">
  import { Text } from "@ui-kit";
  import { formatDate } from "@src/utils";

  const { date } = defineProps<{ date: string }>();
</script>

<template>
  <Text font="body-regular-12" color="tertiary">{{ formatDate(date) }}</Text>
</template>
